import { Outlet } from 'react-router'
import { ImageNotFound } from '../../assets'
import { Divider, ImageStepper, Stack, Typography } from '../../components'
import { useGlobalState, useRemoveMaxWidth, useWindowSize, useZoomDialog } from '../../hooks'
import { ActionGutter } from '../../components/Cards/ActionGutter'

interface StyleflowVisualizeProps {
  visualizerFabric?: TrinityAPI.VisualizerFabricType
}

export function StyleflowVisualize({ visualizerFabric = undefined }: StyleflowVisualizeProps) {
  useRemoveMaxWidth()
  const { onMobile, onTablet, onLaptop } = useGlobalState()
  const { height } = useWindowSize()
  const isMobile = onMobile || onTablet
  const windowSize = height - 90
  const { ZoomDialog, zoomAction } = useZoomDialog(visualizerFabric?.renderedImage ?? ImageNotFound)

  return (
    <Stack
      direction={{ mobile: 'column', laptop: 'row' }}
      spacing={{ mobile: 8, laptop: 0 }}
      height={{ laptop: windowSize }}
      width={{ laptop: '100%' }}
      margin={{ laptop: '-3rem' }} // TODO switch to a shared global main margin value
      justifyContent='flex-end'
      top={{ mobile: 80, laptop: 'auto' }}
      position='absolute'
      left={{ mobile: 0, laptop: 'auto' }}
      right={{ mobile: 0, laptop: 'auto' }}
    >
      <Stack
        bgcolor='neutral.extraLight'
        flexBasis={{ laptop: '50%' }}
        minHeight={{ laptop: '100%' }}
        display='flex'
        sx={{ overflow: 'hidden' }}
      >
        <ActionGutter actions={[zoomAction]} sx={{ right: 'auto', left: '0.75rem' }} />
        <ZoomDialog />
        <ImageStepper alignItems='center' sx={{ flex: 1, justifyContent: 'center', overflow: 'hidden' }}>
          <img
            src={visualizerFabric?.renderedImage.replace('width=500', 'width=1000') ?? ImageNotFound}
            alt={`${visualizerFabric?.fabric?.description} ${visualizerFabric?.garmentType.formalName}`}
            width={isMobile ? 300 : onLaptop ? 500 : 600}
            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: 'calc(100% - 60px)', height: 'auto' }}
          />
          <img
            src={visualizerFabric?.fabric?.swatch ?? ImageNotFound}
            alt={`${visualizerFabric?.fabric?.description} Swatch`}
            width={isMobile ? 300 : onLaptop ? 500 : 600}
            style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: 'calc(100% - 60px)', height: 'auto' }}
          />
        </ImageStepper>
      </Stack>
      <Stack spacing={2} pt={{ mobile: 0, laptop: 4 }} px={{ mobile: 0, laptop: 4 }} flexBasis={{ laptop: '50%' }}>
        <Typography variant='h3' sx={{ pl: { mobile: 4, laptop: 0 } }}>
          {visualizerFabric?.fabric
            ? `${visualizerFabric.fabric?.trinityNumber}${visualizerFabric?.fabric?.position ? ` (${visualizerFabric.fabric.position})` : ''}`
            : `Please Select A ${visualizerFabric ? 'Fabric' : 'Garment'}`}
        </Typography>
        <Typography sx={{ pl: { mobile: 4, laptop: 0 } }}>{visualizerFabric?.fabric?.description}</Typography>
        <Typography sx={{ pl: { mobile: 4, laptop: 0 } }}>{visualizerFabric?.fabric?.collection}</Typography>
        <Divider sx={{ width: 1 }} />
        <Stack sx={isMobile ? {} : { scrollbarWidth: 'thin', overflowY: 'scroll', overflowX: 'hidden' }}>
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}
